import React, { useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

interface CustomTooltipProps {
    children: React.ReactNode;
    text: string;
    placement?: 'top' | 'bottom' | 'left' | 'right';
}

const CustomTooltip = ({ children, text, placement = 'top' }: CustomTooltipProps) => {
    const renderTooltip = (props: any) => (
        <Tooltip id="custom-tooltip" {...props} className="custom-tooltip">
            {text}
        </Tooltip>
    );

    return (
        <OverlayTrigger
            placement={placement}
            delay={{ show: 250, hide: 400 }}
            overlay={renderTooltip}
        >
            <span className="tooltip-wrapper d-inline-flex align-items-center">
                {children}
                <i className="ph-duotone ph-info ms-1 text-muted" style={{ fontSize: '14px', cursor: 'help' }}></i>
            </span>
        </OverlayTrigger>
    );
};

export default CustomTooltip;